<template>
  <div class="SideBar" v-if="visible">
    <div class="side-menus">
      <ul>
        <li
          @click="change(item)"
          :class="['menu', { 'is-active': item.active }]"
          v-for="(item, index) in sideList"
          :key="index"
        >
          <i :class="['icon', item.icon]"></i>
          <span class="value">{{ item.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { sideMenus } from '@/utils/router';
import { sideBarClick } from '@/omega/business/common';
export default {
  name: 'SideBar',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      sideList: [],
    };
  },
  watch: {
    $route(to) {
      this.handleMenus(to.path);
    },
  },
  computed: {
    name() {
      return this.$route?.name;
    },
  },
  mounted() {
    this.handleMenus(this.$route?.path || '');
  },
  methods: {
    handleMenus(path) {
      sideMenus.forEach((menu) => {
        if (menu.name === this.name || !path.indexOf(menu.path)) {
          menu.active = true;
          return;
        }
        menu.active = false;
      });
      this.sideList = sideMenus;
    },
    change(item) {
      if (this.name === item.name) return;
      sideBarClick({ click_type: item.type });
      this.$router.push({ name: item.name });
    },
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
